import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/app/config/environments/environment';
import { VisualizedOccasions } from '../models/interfaces/visualized-occasions.interface';

@Injectable()
export class VisualizedOccasionsService {
  private readonly visualizedPath = 'visualized-occasions';
  private readonly occasionPath = 'occasion';
  private readonly countPath = 'count';

  constructor(private http: HttpClient) {}

  public getById(id: string): Observable<VisualizedOccasions> {
    return this.http.get<VisualizedOccasions>(
      `${environment.api.baseUrl}/${this.visualizedPath}/${id}`
    );
  }

  public getVisualizedByIdOccasion(
    idOccasion: string
  ): Observable<VisualizedOccasions> {
    return this.http.get<VisualizedOccasions>(
      `${environment.api.baseUrl}/${this.visualizedPath}/${this.occasionPath}/${idOccasion}`
    );
  }

  public getCountUsers(idOccasion: string): Observable<number> {
    return this.http.get<number>(
      `${environment.api.baseUrl}/${this.visualizedPath}/${this.occasionPath}/${idOccasion}/${this.countPath}`
    );
  }
}
